import { Routes } from '../config/routes'

import type { RouteConfig } from '../types'
import { OrganizationGuard } from '../guards'

import { OrganizationJobBoardRoot } from '../../containers/JobBoard/OrganizationJobBoard/OrganizationJobBoardRoot'

import { OrganizationProjectRoot } from '../../containers/Organization/pages/OrganizationProjectPage/OrganizationProjectRoot'

import {
    OrganizationSchedule,
    OrganizationHome,
    OrganizationPropertyList,
    OrganizationDirectory,
    LeaseAuditScheduleDetail,
} from '../../containers/Organization'
import { LeaseAuditRoot } from '../../containers/LeaseAudit/LeaseAuditRoot'

import { EZFolioFormsRoot } from '../../containers/EZFolioForms/EZFolioFormsRoot'
import { OrganizationLayout } from '../layouts'
import { OrganizationFacilitiesHome } from '../../containers/OrganizationFacilities/OrganizationFacilitiesHome'
import { PropertyAudit } from '../../containers/PropertyAudit/PropertyAudit'
import { DeadlineHome } from '../../containers/Organization/pages/Deadlines/DeadlineHome'
import { OrganizationContractManager } from '../../containers/Organization/pages/ContractManager'
import { CopyToolPage } from '../../containers/Organization/pages/CopyTool/CopyToolPage'
import { EzFolioConfigurationsPage } from '../../containers/EzFolioConfigurations/EzFolioConfigurationsPage'
import { OrganizationWorkforceRoot } from '../../containers/OrganizationWorkforce/OrganizationWorkforceRoot'
import { OrganizationRFPRoot } from '../../containers/RFP/RFPRoot'
import { DamageHome } from '../../containers/DamageHome/DamageHome'
import { OrganizationInvoiceHome } from '../../containers/Invoice/OrganizationInvoiceHome'
import { InvoiceListRoot } from '../../containers/Invoice/InvoiceListRoot'
import { MoveInSurveyRoot } from '../../containers/MoveInSurvey/MoveInSurveyRoot'

export const organizationRoutes: RouteConfig[] = [
    {
        path: Routes.organization.root,
        component: OrganizationHome,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.jobBoard,
        component: OrganizationJobBoardRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.projects,
        component: OrganizationProjectRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.scheduleDetail,
        component: LeaseAuditScheduleDetail,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.leaseAuditDetail,
        component: LeaseAuditRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.schedule,
        component: OrganizationSchedule,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.directory,
        component: OrganizationDirectory,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.properties,
        component: OrganizationPropertyList,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.propertyForms,
        component: EZFolioFormsRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.facilities,
        component: OrganizationFacilitiesHome,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.workforce,
        component: OrganizationWorkforceRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.rfp.rfpDetail,
        component: OrganizationRFPRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.rfp.rfpDashboard,
        component: OrganizationRFPRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.propertyAudit.root,
        component: PropertyAudit,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.deadlines,
        component: DeadlineHome,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.contractManager,
        component: OrganizationContractManager,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.copyTool,
        component: CopyToolPage,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.configurations,
        component: EzFolioConfigurationsPage,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
        exact: true,
    },
    {
        path: Routes.organization.damages,
        component: DamageHome,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.invoiceList,
        component: InvoiceListRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.invoiceHome,
        component: OrganizationInvoiceHome,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
    {
        path: Routes.organization.moveInSurvey,
        component: MoveInSurveyRoot,
        layout: OrganizationLayout,
        guard: OrganizationGuard,
    },
]
